// Module
var code = "<div class=\"row\"> <div class=\"col-md-12\"> <grid-value-editor grid-options=\"$ctrl.averagePriceForecastOptions\" notify-about-changes=\"$ctrl.recalculateAveragePriceForecastFooter()\"></grid-value-editor> </div> </div> ";
// Exports
module.exports = code;